import { FiasRoomType } from '@skbkontur/react-ui-addons';
export const convertFiasRoomToSSRoom = (roomValue) => {
    const room = roomValue?.data;
    if (!room?.flatFiasId) {
        return;
    }
    const roomType = room?.roomType ? FiasRoomType[room.roomType]?.toLocaleLowerCase() : undefined;
    return {
        type: roomType ?? undefined,
        number: room?.roomNumber ?? undefined,
        fiasId: room.fiasId,
    };
};
